import React, { useState, useEffect, useRef } from "react";
import { TextD, AfterBetP } from "./TextStyled";
import currencies from "../../../lib/currencies/currencies";

// import useSound from "use-sound";
// import winSound from "./audio/win.mp3";
// import tieSound from "./audio/tie.mp3";
// import lostSound from "./audio/lost.mp3";

export default function Text({
  betInfo,
  isAutoOn,
  showText,
  toFix,
  userSettings,
  currency,
}) {
  // const { sound, volume } = userSettings;
  const [wincoef, setwincoef] = useState("");
  const [winAmount, setwinAmount] = useState(false);

  useEffect(() => {
    if (betInfo.dealer.length === 5) {
      if (betInfo.dealer[0] === "0") {
        setwinAmount(false);
      } else {
        setwincoef(betInfo.winCoeff.toFixed(2));
        setwinAmount(betInfo.winAmount.toFixed(toFix));
      }
    }
  }, [betInfo, toFix]);

  const [fadeInAfterAuto, setfadeInAfterAuto] = useState(false);
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (isAutoOn) {
      setfadeInAfterAuto(false);
    } else {
      setfadeInAfterAuto(true);
    }
  }, [isAutoOn]);
  return (
    <TextD fadeInAfterAuto={fadeInAfterAuto} isAutoOn={isAutoOn}>
      {showText &&
        (!!winAmount ? (
          <>
            <AfterBetP delay="320ms" w={betInfo.winAmount}>
              {wincoef}X
            </AfterBetP>
            <AfterBetP delay="520ms" w={betInfo.winAmount}>
              {winAmount} {currencies[currency]}
            </AfterBetP>
          </>
        ) : (
          <>
            <p>FULL HOUSE PAYS</p>
            <p>1 TO 2</p>
          </>
        ))}
    </TextD>
  );
}
